// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-checkbox{position:relative;height:13px;width:13px;border-radius:12px;background-color:#fff;border:1px solid hsla(0,0%,43.9%,.5)}.filter-checkbox__is-checked{background-color:#19a0dd}.filter-checkbox__checkmark{position:absolute;left:3px;top:1px;width:5px;height:8px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg)}", ""]);
// Exports
module.exports = exports;
